import { IrrigationOfficeModel } from './../../../models/irrigation-office.model';
import { createReducer, on } from '@ngrx/store';
import {
  DistrictsModel,
  ProvinceModel,
  SubDistrictsModel,
} from '@roi/common/models/province.model';
import {
  DistrictAction,
  ProvinceAction,
  SubDistrictAction,
  MasterAction,
} from '../actions';
import { YearModel } from '@roi/common/models/water-allocation-years.model';
import { ActivityModel } from '@roi/common/models/activity.model';
import { PlantModel } from '@roi/common/models/plant.model';
import { ProjectModel } from '@roi/common/models/project.model';
import { StatusModel } from '@roi/common/models/water-allocation-status.model';

export interface MasterState {
  provinces: ProvinceModel[];
  districts: DistrictsModel[];
  subDistricts: SubDistrictsModel[];
  years: any[];
  waterUse: ActivityModel[];
  landUse: PlantModel[];
  irrigationOffices: IrrigationOfficeModel[];
  projects: ProjectModel[];
  status: StatusModel[];
  loadingProvinces: boolean;
  loadingDistricts: boolean;
  loadingSubDistricts: boolean;

  error?: ErrorState | null;
}

export const initialGeoState: MasterState = {
  provinces: [],
  districts: [],
  subDistricts: [],
  years: [],
  waterUse: [],
  landUse: [],
  irrigationOffices: [],
  projects: [],
  status: [],
  loadingProvinces: false,
  loadingDistricts: false,
  loadingSubDistricts: false,
  error: null,
};
interface ErrorState {
  incorrect: boolean;
  message: string;
}
export const MasterReducer = createReducer(
  initialGeoState,
  on(ProvinceAction.loadProvinces, (state) => ({
    ...state,
    loadingProvinces: true,
  })),
  on(ProvinceAction.loadProvincesSuccess, (state, { provinces }) => ({
    ...state,
    provinces,
    loadingProvinces: false,
  })),
  on(ProvinceAction.loadProvincesFailure, (state, { error }) => ({
    ...state,
    loadingProvinces: false,
    error,
  })),

  on(DistrictAction.loadDistricts, (state) => ({
    ...state,
    loadingDistricts: true,
  })),
  on(DistrictAction.loadDistrictsSuccess, (state, { districts }) => ({
    ...state,
    districts,
    loadingDistricts: false,
  })),
  on(DistrictAction.loadDistrictsFailure, (state, { error }) => ({
    ...state,
    loadingDistricts: false,
    error,
  })),

  on(SubDistrictAction.loadSubDistricts, (state) => ({
    ...state,
    loadingSubDistricts: true,
  })),
  on(SubDistrictAction.loadSubDistrictsSuccess, (state, { subDistricts }) => ({
    ...state,
    subDistricts,
    loadingSubDistricts: false,
  })),
  on(SubDistrictAction.loadSubDistrictsFailure, (state, { error }) => ({
    ...state,
    loadingSubDistricts: false,
    error,
  })),
  on(MasterAction.SetYears, (state, { years }) => ({
    ...state,
    years,
  })),
  on(MasterAction.SetLandUse, (state, { landUse }) => ({
    ...state,
    landUse,
  })),
  on(MasterAction.SetWaterUse, (state, { waterUse }) => ({
    ...state,
    waterUse,
  })),
  on(MasterAction.SetIrrigationOffices, (state, { irrigationOffices }) => ({
    ...state,
    irrigationOffices,
  })),
  on(MasterAction.SetProjects, (state, { projects }) => ({
    ...state,
    projects,
  })),
  on(MasterAction.SetStatus, (state, { status }) => ({
    ...state,
    status,
  }))
);
